import { HeaderStream } from 'app/library/experience/models/header-stream.model';
import { MaxBrainWidget } from 'app/library/widgets/models/widget.model';
import { IExperienceConfigQuery } from '../interfaces/experience-config.interface';

// @dynamic
export class ExperienceConfig {
    backgroundColor: string;
    textColor: string;
    headerStream: HeaderStream;
    experiencesWidgets: {
        id: string;
        widget: MaxBrainWidget;
        sort: number;
        hasContent?: boolean;
    }[];

    constructor(query?: IExperienceConfigQuery) {
        if (query) {
            this.backgroundColor = query.background_color;
            this.textColor = query.text_color;
            this.headerStream = new HeaderStream(query.header_stream);
            this.experiencesWidgets = query.experiences_widgets.map((experienceWidget) => {
                return {
                    id: experienceWidget.id.toString(),
                    widget: new MaxBrainWidget(experienceWidget.widget),
                    sort: experienceWidget.sort,
                };
            });
        }
    }
}
